import { Component, Input } from '@angular/core';
import { ManagementData } from '../../model/management.model';

@Component({
  selector: 'markant-platform-management-tile-contract-data',
  templateUrl: './contract-data.component.html',
  styleUrls: ['./contract-data.component.scss', '../management-tile.scss'],
})
export class ContractDataManagementTileComponent {
  @Input({ required: true }) managementData!: ManagementData;
}
